// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__A4O3s","customerLabel":"ConfirmDeleteModal_customerLabel__zyh4b","customerBtn":"ConfirmDeleteModal_customerBtn__UPkf8"};